import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { colors, common, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	addButton: {
		alignSelf: 'flex-start',
		gap: spacing.xs,
		marginTop: spacing.xs,
	},
	delegateChip: {
		alignItems: 'center',
		backgroundColor: colors.primary.light,
		borderRadius: common.borderRadius,
		color: colors.text.main,
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		gap: spacing.xs,
		justifyContent: 'space-between',
		padding: `${spacing.xs}px ${spacing.sm}px`,
	},
	delegateList: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	emptyState: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		marginTop: spacing.sm,
		textAlign: 'center',
	},
	formBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	formSection: {
		backgroundColor: colors.background.main,
		border: common.border,
		borderRadius: common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		padding: spacing.sm,
	},
	formSectionEmpty: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
	},
	formSectionHeading: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
		letterSpacing: '0.05em',
		textTransform: 'uppercase',
	},
	iconButton: {
		alignItems: 'center',
		display: 'flex',
		flexShrink: 0,
	},
	pagePanel: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		maxWidth: 720,
		padding: spacing.md,
		width: '100%',
	},
	searchPopup: {
		maxWidth: 420,
	},
	subadminRow: {
		alignItems: 'center',
		backgroundColor: colors.background.main,
		border: common.border,
		borderRadius: common.borderRadius,
		display: 'flex',
		gap: spacing.sm,
		justifyContent: 'space-between',
		padding: spacing.sm,
	},
	subadminRowDetails: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: 2,
	},
	subadminRowSubtitle: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
	},
	subadminRowTitle: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
	},
	title: {
		color: colors.text.main,
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.bold,
	},
});
